import Http from '@/classes/http/Http'
import Transform from '@/classes/form/Transform'

export default {
  getCertificateFormLayout (caseId) {
    return Http.get({
      url: `cases/${caseId}/certificates`
    })
  },
  getCertificateForm (certificateId) {
    return Http.get({
      url: `certificates/${certificateId}/form`
    })
  },
  postCertificateForm (caseId, state, formData) {
    let data = Transform.createMultipartFormData(formData)
    data.append('state', state)
    return Http.post({
      url: `cases/${caseId}/certificates`,
      data: data
    })
  },
  patchCertificateForm (certificateId, state, formData) {
    let data = Transform.createMultipartFormData(formData)
    data.append('state', state)
    return Http.patch({
      url: `certificates/${certificateId}/form`,
      data: data
    })
  },
  getCertificates (filter) {
    return Http.get({
      url: `certificates${filter}`
    })
  },
  getCertificatesUniqueCertNumber (filter) {
    return Http.get({
      url: `certificates-list${filter}`
    })
  },
  getCertificatesExcel (filter, sheetName) {
    return Http.download({
      url: `exports/certificates/${sheetName}/${filter}`
    })
  },
  getCertificate (certificateId) {
    return Http.get({
      url: `certificates/${certificateId}`
    })
  },
  getCertificateData (certificateId) {
    return Http.get({
      url: `certificates/${certificateId}/data`
    })
  },
  postCreateRenewalCase (certificateId) {
    return Http.post({
      url: `certificates/${certificateId}/renewal`
    })
  },
  getRevokeCertificateForm (certificateId) {
    return Http.get({
      url: `certificates/${certificateId}/revoke`
    })
  },
  putRevokeCertificateForm (certificateId, formData) {
    return Http.put({
      url: `certificates/${certificateId}/revoke`,
      data: formData
    })
  },
  getSuspendCertificateForm (certificateId) {
    return Http.get({
      url: `certificates/${certificateId}/suspend`
    })
  },
  putSuspendCertificateForm (certificateId, formData) {
    return Http.put({
      url: `certificates/${certificateId}/suspend`,
      data: formData
    })
  },
  getSuspensionUpdateForm (certificateId) {
    return Http.get({
      url: `certificates/${certificateId}/update-suspension`
    })
  },
  putSuspensionUpdateForm (certificateId, formData) {
    return Http.put({
      url: `certificates/${certificateId}/update-suspension`,
      data: formData
    })
  },
  putUnsuspendCertificate (certificateId) {
    return Http.put({
      url: `certificates/${certificateId}/unsuspend/`
    })
  },
  putSuspensionRegistered (certificateId) {
    return Http.put({
      url: `certificates/${certificateId}/suspension-registered/`
    })
  },
  putRevocationRegistered (certificateId) {
    return Http.put({
      url: `certificates/${certificateId}/revocation-registered/`
    })
  },
  postStartReviseCase (certificateId) {
    return Http.post({
      url: `certificates/${certificateId}/revise/`
    })
  },
  putOrderIdCard (certificateId) {
    return Http.put({
      url: `certificates/${certificateId}/create-id-card-order/`
    })
  }
}
